/** Заявка оператора на допработу (26.08, владелец): время от–до (TimePicker)
 *  + описание → POST /api/extra-work со статусом proposed; деньги оператор
 *  НЕ трогает — ставка встаёт из extra_work_rates, дальше решает ОО.
 *  04.09: вынесена из ExtraTab — одна и та же форма во вкладке «Доп» и в
 *  шите «🔧 Доп.работа» дашборда (ProposeExtraSheet). onDone — ТОЛЬКО после
 *  успешного POST (раньше звался и при ошибке); ошибка остаётся в форме.
 *  04.09 (ревью): alive-ref — после ответа onDone/setState только пока
 *  экземпляр смонтирован (старая форма после ремаунта не закроет НОВЫЙ шит);
 *  onBusyChange — родитель блокирует закрытие шита, пока идёт POST. */
import { useEffect, useRef, useState } from "react";
import { api } from "../../api/client";
import { ApiException } from "../../api/types";
import { TimePicker } from "../../components/shared";
import { fmtDateApi } from "../../utils/date";
import css from "./extraTab.module.css";

export function ProposeExtraForm({ date, onDone, onCancel, onBusyChange }: {
  date: Date; onDone: () => void; onCancel?: () => void; onBusyChange?: (busy: boolean) => void;
}) {
  const [range, setRange] = useState<string | null>(null);
  const [pick, setPick] = useState(false);
  const [desc, setDesc] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  /* alive ставим в теле эффекта: StrictMode в dev гоняет mount→cleanup→mount */
  const alive = useRef(true);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const setBusyUp = (b: boolean) => { setBusy(b); onBusyChange?.(b); };
  const send = async () => {
    const m = (range ?? "").match(/^(\d{2}:\d{2})[–-](\d{2}:\d{2})$/);
    if (!m || !desc.trim() || busy) return;
    setBusyUp(true); setErr(null);
    try {
      await api("/api/extra-work", { method: "POST", body: { date: fmtDateApi(date), time_from: m[1], time_to: m[2], description: desc.trim() } });
      if (alive.current) onDone();
    } catch (e) {
      if (alive.current) setErr(e instanceof ApiException && e.body?.error ? e.body.error : "Не удалось отправить — попробуй ещё раз");
    } finally { if (alive.current) setBusyUp(false); }
  };
  return (
    <div className={css.propose}>
      <button type="button" className={css.propTime} onClick={() => setPick(true)}>{range ?? "⏱ время от–до"}</button>
      <input className={css.propDesc} placeholder="Что делал / что нужно сделать…" value={desc} maxLength={200} onChange={(e) => setDesc(e.target.value)} />
      {err ? <div className={css.propErr}>{err}</div> : null}
      <div className={css.propRow}>
        {onCancel ? <button type="button" className={css.propCancel} disabled={busy} onClick={onCancel}>Отмена</button> : null}
        <button type="button" className={css.propSend} disabled={!range || !desc.trim() || busy} onClick={() => void send()}>{busy ? "Отправляю…" : "Отправить в ОО"}</button>
      </div>
      {pick ? <TimePicker open mode="range" step={5} label="Доп — время от и до" value={range ?? undefined} onCommit={(v) => { setRange(v); setPick(false); }} onCancel={() => setPick(false)} /> : null}
    </div>
  );
}
